import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'ShoppingCart',
  //   description: 'description of ShoppingCart',
  //   url: '/shopping-cart',
  // },
];

export default help;
